import { ChakraProvider, extendTheme } from '@chakra-ui/react';

import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import SideNavigation from '../SideNavigation/main.js';

import './index.css';
import { useContext, useEffect, useMemo } from 'react';
import { UserContext } from '@adflow/utils';

export function Root() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (location.pathname !== '/' && location.pathname !== '/creative-hub') {
      return;
    }

    const redirectToDefaultPage = async () => {
      if (!user) {
        navigate('no-access');
        return;
      }

      const sections = [
        { resourceType: 'ad-tag', path: 'templates' },
        { resourceType: 'catalogue', path: 'templates' },
        { resourceType: 'video-tag', path: 'video-tags' },
      ];

      for (const section of sections) {
        const canRead = await user.canRead('creative-hub', section.resourceType);
        if (canRead) {
          navigate(section.path);
          return;
        }
      }

      navigate('no-access');
    };

    redirectToDefaultPage();
  }, [location, navigate, user]);

  const theme = useMemo(() => {
    return extendTheme({
      fonts: {
        heading: 'Source Sans Pro',
        body: 'Source Sans Pro',
      },
    });
  }, []);

  return (
    <div id="creative-hub-container">
      <ChakraProvider theme={theme}>
        <SideNavigation />
        <div id="main">
          <Outlet />
        </div>
      </ChakraProvider>
    </div>
  );
}
